module.exports = __webpack_public_path__ + "static/servicios-lechugas-5102ac464ac8b69da2b53f047fb8a3aa.png";